// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"63":"fd80bdbd6cc4bc8e","720":"2681262da0234047","908":"2a3e1431792fd50e"}[chunkId] + ".js";
};